import Ethereum from './1.webp';
import BSC from './56.webp';
import Solana from './501.webp';
import Base from './8453.webp';
import Arbitrum from './arbitrum.svg';
import Unknown from './unknown.svg';

const ICONS = {
  1: Ethereum,
  56: BSC,
  501: Solana,
  8453: Base,
  42161: Arbitrum,
  421614: Arbitrum,
  default: Unknown,
};

export default ICONS;
